import Logo from 'assets/images/icons/logo.png';
import LogoTc from 'assets/images/icons/logo-tc.png';
import LogoEn from 'assets/images/icons/logo-en.png';
import MobileLogo from 'assets/mobile/icons/mobile-logo.png';
import MobileLogoEn from 'assets/mobile/icons/mobile-logo-en.png';
import MobileLogoTc from 'assets/mobile/icons/mobile-logo-tc.png';
import logoSVG from 'assets/images/logo.svg';
import logoEnSVG from 'assets/images/logo-en.svg';
import logoTcSVG from 'assets/images/logo-tc.svg';

import logoWhiteSVG from 'assets/images/logo-white.svg';
import logoEnWhiteSVG from 'assets/images/logo-en-white.svg';
import logoTcWhiteSVG from 'assets/images/logo-tc-white.svg';
// 桌面端LOGO
export function getLogo(locale: string) {
    switch (locale) {
        case 'en':
            return LogoEn;
        case 'tc':
            return LogoTc;
        default:
            return Logo;
    }
}

// 移动端LOGO
export function getMobileLogo(locale: string) {
    switch (locale) {
        case 'en':
            return MobileLogoEn;
        case 'tc':
            return MobileLogoTc;
        default:
            return MobileLogo;
    }
}

// 移动端LOGO
export function getLogoSVG(locale: string) {
    switch (locale) {
        case 'en':
            return logoEnSVG;
        case 'tc':
            return logoTcSVG;
        default:
            return logoSVG;
    }
}

// 移动端LOGO
export function getLogoWhiteSVG(locale: string) {
    switch (locale) {
        case 'en':
            return logoEnWhiteSVG;
        case 'tc':
            return logoTcWhiteSVG;
        default:
            return logoWhiteSVG;
    }
}
